import type { ReactNode } from 'react';
import classes from './EmptyState.module.css';

interface EmptyStateProps {
  /** `helmet` = brand moment (empty lists, placeholders); `warn`/`danger` = an icon in a soft circle. */
  variant: 'helmet' | 'warn' | 'danger';
  icon?: ReactNode;
  title: string;
  body: string;
  action?: ReactNode;
  /** Compact padding for in-panel use. */
  compact?: boolean;
}

/** Centred empty / error / no-access state inside a surface card. */
export function EmptyState({
  variant,
  icon,
  title,
  body,
  action,
  compact = false,
}: EmptyStateProps) {
  return (
    <div className={classes.root} data-compact={compact || undefined}>
      {variant === 'helmet' ? (
        <div className={classes.helmet}>
          <img src="/brand/helmet.png" alt="" height={64} />
        </div>
      ) : (
        <div className={classes.iconWrap} data-variant={variant}>
          {icon}
        </div>
      )}
      <strong className={classes.title}>{title}</strong>
      <span className={classes.body}>{body}</span>
      {action}
    </div>
  );
}
